import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../shared/constants/api.constants';
import { RequestCacheService } from '../core/http/request-cache.service';

/** Banners are merchandising content, not prices - a short cache avoids refetching on every home visit. */
const BANNER_TTL_MS = 5 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class BannerService {

  constructor(private http: HttpClient, private cache: RequestCacheService) { }

  getBanners(): Observable<any> {
    return this.cache.get('banners', BANNER_TTL_MS, () => this.http.get<any>(API_ENDPOINTS.GET_BANNERS));
  }

}
